export default __webpack_public_path__ + "static/media/dialogClose.a30c91c5.svg";